import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router, UrlTree } from '@angular/router';
import { OnboardingService } from '../../services/onboarding-service';
import { WELCOME_SCREEN_1 } from '@storees/shared-constants';

@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  private router = inject(Router);
  private onboardingService = inject(OnboardingService);


  async canActivate(): Promise<boolean | UrlTree> {
    const completed = await this.onboardingService.isComplete();
    if (!completed) {
      return this.router.createUrlTree([WELCOME_SCREEN_1]);
    }
    return true;
  }
}

// Functional guard export to support tests expecting a CanActivateFn
export const onboardingGuard: CanActivateFn = () => inject(OnboardingGuard).canActivate();
